// ──────────────────────────────────────────────────────────────────────────
// Datos del usuario logueado, leidos del AuthContext.
//
// OJO con la forma del objeto: el dispatch LOGIN (ver SSOLogin.js y Login.js)
// arma `user` en snake_case, no en PascalCase:
//
//     user: { email, id_usuario, id_empleado, name, fullName, photo }
//
// No existen `user.IdEmpleado`, `user.IdUsuario` ni `user.id`. Leerlos daba
// undefined, y `Number(undefined)` es NaN, que JSON.stringify serializa como
// null — asi es como AplicarConvocatoria terminaba mandando IdEmpleado en null.
// ──────────────────────────────────────────────────────────────────────────

export const getIdEmpleadoSesion = (state) => state?.user?.id_empleado ?? null;

export const getIdUsuarioSesion = (state) => state?.user?.id_usuario ?? null;
